import { NavigationModal } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { reportsConstants } from 'locale/team'
import { useTranslation } from 'react-i18next'
import { type SiteRemoval, SiteRemovalKind } from './siteRemoval'

type SiteRemovalWarningModalProps = {
  firstName?: string
  onCancel: () => void
  onConfirm: () => void
  removal: SiteRemoval
  testId?: string
}

const SiteRemovalWarningModal = ({
  firstName,
  onCancel,
  onConfirm,
  removal,
  testId
}: SiteRemovalWarningModalProps) => {
  const { t } = useTranslation(NAMESPACE.TEAM)

  if (removal.kind === SiteRemovalKind.NONE) {
    return null
  }

  const isDeactivation = removal.kind === SiteRemovalKind.DEACTIVATE

  // Naming the site only reads correctly when a single one is going — with several
  // going, naming one would claim it is their only access when it is not.
  let bodyKey = reportsConstants.SITE_REMOVAL_SWITCH_BODY
  if (removal.kind === SiteRemovalKind.DEACTIVATE) {
    bodyKey =
      removal.removedSiteCount > 1
        ? reportsConstants.SITE_REMOVAL_DEACTIVATE_BODY_MULTIPLE
        : reportsConstants.SITE_REMOVAL_DEACTIVATE_BODY
  }

  const interpolation = {
    currentSite:
      removal.currentSiteName || t(reportsConstants.SITE_REMOVAL_FALLBACK_SITE),
    name: firstName?.trim() || t(reportsConstants.SITE_REMOVAL_FALLBACK_NAME),
    nextSite: isDeactivation ? undefined : removal.nextSiteName
  }

  return (
    <NavigationModal
      cancelNavigation={onCancel}
      confirmButtonProps={{ variant: 'primary' }}
      confirmNavigation={onConfirm}
      data-testid={testId}
      modalCancelText={t(reportsConstants.SITE_REMOVAL_CANCEL)}
      modalConfirmText={t(reportsConstants.SITE_REMOVAL_CONFIRM)}
      modalContentText={t(bodyKey, interpolation)}
      modalTitle={t(
        isDeactivation
          ? reportsConstants.SITE_REMOVAL_DEACTIVATE_TITLE
          : reportsConstants.SITE_REMOVAL_SWITCH_TITLE
      )}
      showPrompt
    />
  )
}

export default SiteRemovalWarningModal
